"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _colors = require("../../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HomeIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(HomeIcon, _PureComponent);

  function HomeIcon() {
    _classCallCheck(this, HomeIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(HomeIcon).apply(this, arguments));
  }

  _createClass(HomeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          solid = _this$props.solid;
      var style = solid ? {
        fill: color,
        enableBackground: 'new 0 0 63 63'
      } : {
        fill: 'none',
        stroke: color,
        strokeWidth: '1.5px'
      };
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 45.454 35.347",
        style: style,
        alt: "Home"
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M22.109,41.22,7.561,53.2V66.134A1.263,1.263,0,0,0,8.823,67.4l8.842-.023a1.263,1.263,0,0,0,1.256-1.263V58.559A1.263,1.263,0,0,1,20.184,57.3h5.05A1.263,1.263,0,0,1,26.5,58.559v7.547a1.263,1.263,0,0,0,1.263,1.266L36.6,67.4a1.263,1.263,0,0,0,1.263-1.263V53.193L23.316,41.22a.962.962,0,0,0-1.207,0Zm22.98,8.144-6.6-5.437V33a.947.947,0,0,0-.947-.947H33.127A.947.947,0,0,0,32.18,33v5.729l-7.064-5.812a3.788,3.788,0,0,0-4.813,0L.328,49.364A.947.947,0,0,0,.2,50.7l2.012,2.446a.947.947,0,0,0,1.334.129l18.56-15.287a.962.962,0,0,1,1.207,0L41.877,53.272a.947.947,0,0,0,1.334-.126L45.223,50.7a.947.947,0,0,0-.134-1.336Z",
        transform: "translate(0.016 -32.05)"
      }));
    }
  }]);

  return HomeIcon;
}(_react.PureComponent);

HomeIcon.defaultProps = {
  color: _colors.fontColorSecondary,
  solid: true
};
exports.default = HomeIcon;